import { render, staticRenderFns } from "./ProductCustomColor.vue?vue&type=template&id=b7299bf0&scoped=true&"
import script from "./ProductCustomColor.vue?vue&type=script&lang=js&"
export * from "./ProductCustomColor.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomColor.vue?vue&type=style&index=0&id=b7299bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7299bf0",
  null
  
)

export default component.exports